module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.eot
// module id = ../../../../../src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.eot
// module chunks = styles